import { render, staticRenderFns } from "./SearchPagination.vue?vue&type=template&id=e5c01e8c&scoped=true&"
import script from "./SearchPagination.vue?vue&type=script&lang=js&"
export * from "./SearchPagination.vue?vue&type=script&lang=js&"
import style0 from "./SearchPagination.vue?vue&type=style&index=0&id=e5c01e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c01e8c",
  null
  
)

export default component.exports